import { ScanLine, CheckCircle2, RefreshCw } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const HotesseScanner = () => {
  const [code, setCode] = useState('');
  const [validated, setValidated] = useState<{ name: string; prize: string; code: string } | null>(
    null
  );

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!code.trim()) return;
    setValidated({ name: 'Koffi Arman', prize: 'Billet VIP Didi B', code: code.toUpperCase() });
    toast.success('Lot validé avec succès');
    setCode('');
  };

  return (
    <DashboardLayout
      role="hotesse"
      user={{ name: 'Anike Aya', subtitle: 'Hôtesse Admin', initials: 'AA' }}
    >
      <PageHeader
        title="Scanner un participant"
        subtitle="Scanne le QR code du gagnant ou saisis le code manuellement."
      />

      <div className="grid gap-6 lg:grid-cols-[1.2fr_1fr]">
        <div className="rounded-2xl border border-border bg-card p-6 shadow-soft">
          <div className="aspect-square w-full overflow-hidden rounded-xl bg-foreground">
            <div className="grid h-full place-items-center">
              <div className="text-center text-background">
                <div className="mx-auto mb-4 grid size-16 place-items-center rounded-2xl bg-primary text-primary-foreground shadow-cta">
                  <ScanLine className="size-8" />
                </div>
                <p className="font-display text-lg font-bold">Caméra prête</p>
                <p className="mt-1 text-xs text-background/70">Vise le QR code du participant</p>
                <div className="relative mx-auto mt-6 size-48 rounded-2xl border-2 border-primary/60">
                  <div className="absolute inset-x-0 top-1/2 h-0.5 animate-pulse bg-primary" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <form
            onSubmit={submit}
            className="rounded-2xl border border-border bg-card p-6 shadow-soft"
          >
            <Label htmlFor="code" className="text-sm font-semibold">
              Saisie manuelle du code
            </Label>
            <p className="mb-3 text-xs text-muted-foreground">
              Format : 3 caractères + tiret + 4 caractères (ex. JZ4-X72K).
            </p>
            <div className="flex gap-2">
              <Input
                id="code"
                placeholder="JZ4-X72K"
                value={code}
                onChange={e => setCode(e.target.value)}
                className="font-mono uppercase"
              />
              <Button type="submit" className="shadow-cta">
                Valider
              </Button>
            </div>
          </form>

          {validated ? (
            <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/5 p-6 shadow-soft">
              <div className="flex items-start gap-3">
                <span className="grid size-10 place-items-center rounded-full bg-emerald-500/15 text-emerald-600">
                  <CheckCircle2 className="size-5" />
                </span>
                <div className="flex-1">
                  <p className="font-display text-lg font-bold text-emerald-700">Lot remis ✓</p>
                  <p className="mt-1 text-sm text-foreground">{validated.name}</p>
                  <p className="text-xs text-muted-foreground">{validated.prize}</p>
                  <code className="mt-3 inline-block rounded-md bg-card px-2 py-1 font-mono text-xs">
                    {validated.code}
                  </code>
                </div>
                <Button variant="ghost" size="icon" onClick={() => setValidated(null)}>
                  <RefreshCw className="size-4" />
                </Button>
              </div>
            </div>
          ) : (
            <div className="rounded-2xl border border-dashed border-border bg-card/50 p-6 text-center text-sm text-muted-foreground">
              Le résultat de la validation s'affichera ici.
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default HotesseScanner;
